export default __webpack_public_path__ + "static/sm-c0f417c2860c26b2076a774eca77d47c.svg";